const buttonBase = {
  border: '1.5px solid #E0E0E0',
  borderRadius: '8px',
  color: '#292929',
  fontFamily: 'Red Hat Display Bold',
  fontSize: '14px',
  margin: '0px 10px 10px',
  textTransform: 'capitalize',
};

export const retroStyles = {
  actionRow: {
    display: 'flex',
    justifyContent: 'flex-end',
    paddingTop: '15px',
  },
  button: buttonBase,
  centerBlock: { paddingTop: '30px', textAlign: 'center' },
  closeText: {
    color: '#292929',
    fontFamily: 'Red Hat Display Bold',
    textDecoration: 'underLine',
  },
  consultantName: { fontFamily: 'Red Hat Display Bold', fontSize: 15 },
  dateRange: {
    color: '#979598',
    fontFamily: 'Red Hat Display SemiBold',
    fontSize: 12,
    paddingTop: '4px',
  },
  doneBlock: { paddingTop: '40px', textAlign: 'center' },
  doneCheck: { color: '#1D9900', fontSize: 40 },
  doneSubtitle: {
    color: '#979598',
    fontFamily: 'Red Hat Display SemiBold',
    fontSize: 12,
    paddingBottom: '20px',
    paddingTop: '5px',
  },
  doneTitle: {
    fontFamily: 'Red Hat Display Bold',
    fontSize: 15,
    paddingTop: '5px',
  },
  emptyCell: {
    color: '#241a2e',
    fontFamily: 'Red Hat Display SemiBold',
    fontSize: '14px',
    textAlign: 'center',
  },
  fieldLabel: {
    color: '#979598',
    fontFamily: 'Red Hat Display SemiBold',
    fontSize: 11,
    letterSpacing: '0.5px',
    textTransform: 'uppercase',
  },
  fieldLabelSpaced: {
    color: '#979598',
    fontFamily: 'Red Hat Display SemiBold',
    fontSize: 11,
    letterSpacing: '0.5px',
    paddingTop: '15px',
    textTransform: 'uppercase',
  },
  fullWidth: { width: '100%' },
  headerActions: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'flex-end',
  },
  inlineRow: {
    alignItems: 'baseline',
    display: 'flex',
    gap: '10px',
    paddingTop: '10px',
  },
  modalBox: {
    bgcolor: 'background.paper',
    borderRadius: '10px',
    boxShadow: 24,
    display: 'flex',
    flexDirection: 'column' as const,
    height: '90vh',
    left: '50%',
    maxHeight: 750,
    overflowY: 'scroll !important',
    p: 4,
    position: 'absolute' as const,
    top: '50%',
    transform: 'translate(-50%, -50%)',
    width: 800,
  },
  mutedNote: {
    color: '#979598',
    fontFamily: 'Red Hat Display SemiBold',
    fontSize: 12,
  },
  noTargetBox: {
    border: '1.5px dashed #E0E0E0',
    borderRadius: '8px',
    marginTop: '5px',
    padding: '20px 10px',
    textAlign: 'center',
  },
  payPeriodDate: {
    color: '#241A2E',
    fontFamily: 'Red Hat Display SemiBold',
    fontSize: 12,
  },
  payPeriodRow: {
    alignItems: 'center',
    backgroundColor: '#F4F4F6',
    borderRadius: '16px',
    display: 'flex',
    gap: '8px',
    justifyContent: 'space-between',
    marginTop: '6px',
    padding: '5px 6px 5px 14px',
  },
  projectName: {
    fontFamily: 'Red Hat Display Bold',
    fontSize: 13,
    paddingTop: '6px',
  },
  projectNameFlush: { fontFamily: 'Red Hat Display Bold', fontSize: 13 },
  reasonError: {
    color: '#BF0000',
    fontFamily: 'Red Hat Display SemiBold',
    fontSize: 12,
    paddingTop: '3px',
  },
  reasonLabel: {
    fontFamily: 'Red Hat Display Bold',
    fontSize: 13,
    paddingBottom: '5px',
  },
  rejectButton: { ...buttonBase, backgroundColor: '#BF0000', color: '#FFFFFF' },
  rowBetween: {
    alignItems: 'center',
    display: 'flex',
    gap: '8px',
    justifyContent: 'space-between',
  },
  section: { paddingTop: '15px' },
  sectionAuto: { marginTop: 'auto' },
  spinner: { color: '#340000' },
  weekTable: {
    border: '1px solid #E7E7E9',
    borderRadius: '8px',
    marginTop: '8px',
    maxHeight: 230,
    overflowY: 'auto',
  },
};
